/**
 * Mothballed RFQ tabs (Peter, 2026-09-22). Manual (hand-built quote cards) and Request (taker RFQs, probe ladders,
 * MVE builder) were experimental and never used on the live lane, so a trader must not be able to open them by
 * accident — but the code stays, compiled and tested, for when we pick them back up.
 *
 * This list is the ONE switch. A pane named here:
 *   - is dropped from the RFQ tab bar (src/types/navigation.ts) and from the number-key hotkeys (useRfqHotkeys);
 *   - redirects to the Board when its URL is opened directly (views/Rfq/index.tsx);
 *   - loses the links that jump into it (the Board's "Card" button opens Manual).
 * Its components, hooks, stores and relay routes are untouched. The taker half is also off server-side unless
 * RFQ_TAKER_ALLOWED=1. To bring a pane back, delete it from this list.
 */
// 2026-10-09: Request came back as the Taker tab (Paine's brief); Stream's P4 pane lives inside it as the previous
// version. Manual stays mothballed.
export const MOTHBALLED_RFQ_PANES = ['manual'] as const;

export type MothballedRfqPane = (typeof MOTHBALLED_RFQ_PANES)[number];

/** Mothballed auto-quoter MODES (Peter, 2026-10-11: "mothball approve mode and get its buttons off of the desk bar").
 *  A mode named here loses its chip and buttons on the control bar, its knob group and its proposals panel; the relay
 *  refuses to set it (409). Everything stays compiled. Delete it from this list to bring it back. */
export const MOTHBALLED_RFQ_MODES = ['approve'] as const;

export function isMothballedRfqMode(mode: string): boolean {
  return (MOTHBALLED_RFQ_MODES as readonly string[]).includes(mode);
}

export function isMothballedRfqPane(pane: string): boolean {
  return (MOTHBALLED_RFQ_PANES as readonly string[]).includes(pane);
}

/** `/rfq/manual`, `/rfq/manual/…`, `/rfq/manual?ticker=…` → true while Manual is mothballed. */
export function isMothballedRfqPath(path: string): boolean {
  const m = /^\/rfq\/([^/?#]+)/.exec(path);
  return !!m && isMothballedRfqPane(m[1]);
}
